var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#17bae0;}.b{fill:none;stroke:#fff;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-636 -435)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(636 435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14147.736-2468.791l2.044,2.044,4.243-4.243",
    transform: "translate(-13504.88 2913.868)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/ok_icon.07a843c313c3ee75cef1f734ecea7b4a.svg";
export { ForwardRef as ReactComponent };